export default __webpack_public_path__ + "static/media/Hair_3_M_C2.483789ff.svg";